import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link as RealLink, withRouter } from 'react-router-dom';
import { Button } from 'antd';

import URL from '../../helpers/url';

class Link extends Component { // eslint-disable-line fp/no-class
  handleClick = (event) => {
    event.preventDefault();
    const { to, history } = this.props;
    history.push(URL(to, this.props));
  };

  render() {
    const { button, p: props, disabled, children } = this.props;
    if (disabled === true && button === true) {
      return <Button disabled>{children}</Button>;
    }

    if (button === true) {
      return (
        <Button onClick={this.handleClick} {...props}>
          {children}
        </Button>
      );
    }

    const { className, style } = this.props;
    return (
      <RealLink className={className} style={style} to="#" onClick={this.handleClick}>
        {children}
      </RealLink>
    );
  }
}

Link.propTypes = {
  button: PropTypes.bool,
  children: PropTypes.any,
  className: PropTypes.any,
  disabled: PropTypes.bool,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  p: PropTypes.any,
  style: PropTypes.any,
  to: PropTypes.any,
};

export default withRouter(Link);
